<template>
  <v-dialog
    v-model="mapDialog"
    max-width="900px"
    persistent
    :retain-focus="false"
  >
    <v-card>
      <v-card-title>
        <v-icon dense large color="green">add_location</v-icon>
        <span class="text-h5">{{ routeName }} {{ $t("common.select") }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <VMap
            :categoryId="cId"
            :showPoints="points"
            showType="locSelect"
            @locSelected="onLocSelected"
            :mapZoom.sync="zoom"
            :mapCenter.sync="center"
            :selectedCoords="coords"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn color="blue darken-1" text @click="confirm">
          {{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VMap from "@/components/ui/VMap.vue";

export default {
  components: { VMap },
  props: {
    type: String,
    mapDialog: Boolean,
    cId: String,
    routeName: String,
    points: Object,
  },
  data() {
    return {
      coords: [],
      center: [],
      zoom: 9,
    };
  },
  created() {
    const jwt = this.$store.getters["auth/jwtDecoded"];
    if (jwt.city_code === "59") {
      this.center = [27.511675, 40.978092];
      this.cityCenter = [27.511675, 40.978092];
    } else {
      this.center = [36.33534518345682, 41.295020754851635];
      this.cityCenter = [36.33534518345682, 41.295020754851635];
    }
    this.coords = [this.points.lon, this.points.lat];
  },
  methods: {
    close() {
      this.mapDialog = false;
      if (this.type != "incident")
        this.coords = [this.points.lon, this.points.lat];
      else this.coords = [];
      const jwt = this.$store.getters["auth/jwtDecoded"];
      if (jwt.city_code === "59") {
        this.center = [27.511675, 40.978092];
        this.cityCenter = [27.511675, 40.978092];
      } else {
        this.center = [36.33534518345682, 41.295020754851635];
        this.cityCenter = [36.33534518345682, 41.295020754851635];
      }
      this.zoom = 9;
      this.$emit("cancelledLoc", this.coords);
    },
    confirm() {
      this.$emit("confirmedLoc", this.coords);
      this.close();
    },
    onLocSelected(coordinates, zoomLevel) {
      this.coords = [coordinates[0], coordinates[1]];
      this.center = [coordinates[0], coordinates[1]];
      this.zoom = zoomLevel;
    },
  },
  watch: {
    points() {
      this.coords = [this.points.lon, this.points.lat];
    },
  },
};
</script>

<style>
</style>